module.exports = __webpack_public_path__ + "static/media/data-warning.49e0f143.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/data-warning.svg
// module id = 147
// module chunks = 0